import { Route, Routes, useLocation } from "react-router-dom";

// import pages
import Home from "./pages/Home";
import Header from "./pages/layout/Header";
import About from "./pages/about/About";
import Articles from "./pages/articles/Articles";
import Classes from "./pages/classes/Classes";
import Videos from "./pages/Videos/Videos";
import Shop from "./pages/shop/Shop";
import Register from "./pages/auth/Register";
import Contact from "./pages/auth/Contact";
import Question from "./pages/question/Question";
import Footer from "./pages/layout/Footer";
import ScrollTopBtn from "./components/ScrollTopBtn";
import Thanks from "./pages/thanks/Thanks";
import BuilderPage from "./pages/BuilderPage";

const App = () => {
  const location = useLocation();

  return (
    <>
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/articles" element={<Articles />} />
        <Route path="/classes" element={<Classes />} />
        <Route path="/videos" element={<Videos />} />
        <Route path="/shop" element={<Shop />} />
        <Route path="/register" element={<Register />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/question" element={<Question />} />
        <Route path="/thanks" element={<Thanks />} />
        <Route path="*" element={<BuilderPage />} />
      </Routes>
      {!["/", "/about"].includes(location.pathname) && <Footer />}
      <ScrollTopBtn />
    </>
  );
};

export default App;
